import CustomCardHeader from "../../components/card/CustomCardHeader";
import {SemiTransparentButton} from "../../components/CustomButton";
import CardBody from "../../components/card/CardBody";
import CustomCard from "../../components/card/CustomCard";
import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import ManageBlogsGrid from "./components/ManageBlogsGrid";
import {BLOG_STATE_ACTIVE, BLOG_STATE_DRAFT, BLOG_STATE_INACTIVE, BLOG_TAB_TAGS} from "./constants";
import {resetManageBlogs, setManageBlogModals, setSelectedTab} from "../../redux/slices/manageBlogSlice";
import BlogsPaginator, {TagsPaginator} from "./BlogsPaginator";
import {useNavigate} from "react-router-dom";
import BlogTagsFormModal from "./components/BlogTagsFormModal";
import ManageTagsConfirmModal from "./components/ManageTagsConfirmModal";
import ManageBlogsConfirmModal from "./components/ManageBlogsConfirmModal";
import {capitalizeFirstLetter} from "../../helpers/stringHelper";
import BlogMetaDataModal from "./components/BlogMetaDataModal";
import {CommonTabGroup} from "components/tab/TabGroup";
import {CommonTab} from "components/tab/CustomTab";
import BlogTagsGrid from "./components/BlogTagsGrid";
import {isSuperAdmin} from "../../helpers/helperFunctions";

export default function BlogList() {

  const dispatch = useDispatch();

  useEffect(() => {

    return () => {
      dispatch(resetManageBlogs());
    };
  }, []);


  return (
    <>
      <div className="px-3 md:px-8 h-auto -mt-24">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-6 gap-2 px-4 mb-16">
            <div className="lg:col-span-4 mb-16">
              <CustomCard>
                <CustomCardHeader color="blue" contentPosition="none" className="pd-y-0">
                  <div className="flex items-center justify-between w-full">
                    <h2 className="text-2xl text-white">Blogs</h2>
                    <CreateBlogsButton/>
                  </div>
                </CustomCardHeader>
                <CardBody>
                  <BlogsTab/>
                  <ManageBlogsGrid/>
                  <BlogsPaginator/>
                </CardBody>
              </CustomCard>
            </div>
            <div className="lg:col-span-2 mb-16">
              <CustomCard>
                <CustomCardHeader contentPosition="none">
                  <div className="w-full flex items-center justify-between">
                    <h2 className="text-white text-2xl">Tags</h2>
                    <CreateTagsButton/>
                  </div>
                </CustomCardHeader>
                <CardBody className="p-0">
                  <div className=" grid grid-cols-1 2xl:grid-cols-2">
                    <BlogTagsGrid/>
                  </div>
                  <TagsPaginator/>
                </CardBody>
              </CustomCard>
            </div>

          </div>
        </div>
      </div>
      <BlogTagsFormModal/>
      <ManageTagsConfirmModal/>
      <ManageBlogsConfirmModal/>
      <BlogMetaDataModal/>
    </>
  );
}


const BlogsTab = () => {
  const selectedTab = useSelector((state) => state.manageBlogs.selectedTab);
  // const _user = useSelector((state) => state.authToken.user);
  const dispatch = useDispatch();

  const isDraftTabSelected = selectedTab === BLOG_STATE_DRAFT;
  const isActiveTabSelected = selectedTab === BLOG_STATE_ACTIVE;
  const isInactiveTabSelected = selectedTab === BLOG_STATE_INACTIVE;

  return (

    <CommonTabGroup>
      <CommonTab
        active={isActiveTabSelected}
        onClick={() => dispatch(setSelectedTab({tab: BLOG_STATE_ACTIVE}))}>
        {capitalizeFirstLetter(BLOG_STATE_ACTIVE)}
      </CommonTab>
      <CommonTab
        active={isDraftTabSelected}
        onClick={() => dispatch(setSelectedTab({tab: BLOG_STATE_DRAFT}))}>
        {capitalizeFirstLetter(BLOG_STATE_DRAFT)}
      </CommonTab>
      <_UnpublishedTab isSelected={isInactiveTabSelected}/>
    </CommonTabGroup>
  );
};

const _UnpublishedTab = ({isSelected = false}) => {

  const dispatch = useDispatch();

  const _user = useSelector((state) => state.authToken.user);

  const handleClick = () => {
    dispatch(setSelectedTab({tab: BLOG_STATE_INACTIVE}));
  };

  return (
    <>
      {isSuperAdmin(_user) &&
        <CommonTab
          active={isSelected}
          onClick={handleClick}>
          {/* {capitalizeFirstLetter(BLOG_STATE_INACTIVE)} */}
          Unpublished
        </CommonTab>}
    </>

  );
};

const CreateBlogsButton = () => {

  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/blogs/create");
  };

  return (
    <SemiTransparentButton onClick={handleClick}>
      + Create Blog
    </SemiTransparentButton>
  );
};

const CreateTagsButton = () => {

  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(setManageBlogModals({modal: true, isTag: true}));
  };

  return (
    <SemiTransparentButton onClick={handleClick}>
      + Add
    </SemiTransparentButton>
  );
};